export const enum NameValueEditorPair {
  Name = 0,
  Value,
  Index,
}
